import React, { useEffect, useState } from 'react';
import { CustomerWorkoutSessionCreateSetFormData } from '../beans/customer.workout.session.create.form.data';
import moment from 'moment';
import {
    ProgramSession,
    ProgramSessionCreateRequest,
    ProgramSessionSetCreateRequest,
    ProgramSessionSetStatusEnum,
    ProgramSessionUpdatDateRequest,
    Session,
    SetTransitByExerciseRequest,
    User,
} from 'src/api/entities';
import { FormManager } from 'src/_shared/managers/form.manager';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { PopupManager } from 'src/_shared/managers/popup.manager';
import { WorkoutManager } from 'src/_shared/managers/workout.manager';
import { WorkoutSessionManager } from 'src/_shared/managers/workout.session.manager';
import { WorkoutSessionSetManager } from 'src/_shared/managers/workout.session.set.manager';
import { WorkoutSetManager } from 'src/_shared/managers/workout.set.manager';
import { RouteEnum } from 'src/_shared/routes';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { WorkoutSession } from 'src/api/entities/workout-session';
import { PopupType } from 'src/features/_shared/components/Popup/popup.item';
import {
    WorkoutSessionCreateUpdate,
    setWorkoutSessionItems,
    setWorkoutSessionItem,
    setWorkoutSessionSetItems,
    setSelectedWorkoutSessionDate,
    resetWorkoutSessionCreateUpdate,
    setSessionSummary,
} from 'src/features/workout/store/workout.session.slice';
import { Button } from 'src/features/_shared/components/Button/button.component';
import { Calendar } from 'src/features/_shared/components/DatePicker/datepicker.component';
import { DashboardManager } from 'src/_shared/managers/dashboard.manager';
import { EventCalendar } from 'src/features/exercise/utils/eventcalendar';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import { WorkoutSessionSetTransitManager } from 'src/_shared/managers/workout.session.set.transit.manager';
import { PageTransition } from 'src/features/_shared/components/PageTransition/page.transition.component';

export const WorkoutSessionsView: React.FC = () => {
    const dashboardManager = DashboardManager.getInstance();
    const navigationManager = NavigationManager.getInstance();
    const workoutSetManager = WorkoutSetManager.getInstance();
    const workoutSessionManager = WorkoutSessionManager.getInstance();
    const workoutSessionSetManager = WorkoutSessionSetManager.getInstance();
    const workoutSessionSetTransitManager = WorkoutSessionSetTransitManager.getInstance();
    const notificationManager = PopupManager.getInstance();
    const workoutItem: Session = useStoreSelector(state => state.reducer.customerSlice.workout);

    const workoutSessions: WorkoutSession[] = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessions);
    const workoutSessionCreateUpdate: WorkoutSessionCreateUpdate = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessionCreateUpdate);
    const customerItem: User = useStoreSelector(state => state.reducer.customerSlice.customer);
    const [selectedDate, setSelectedDate] = useState<string>('');

    const getWorkoutSessions = async () => {
        const value = (await workoutSessionManager.search(customerItem.id, workoutItem.id!)).data!;
        console.log(value);
        store.dispatch(setWorkoutSessionItems({ value }));
    };

    const handleCreateWorkoutSession = async () => {
        console.log(customerItem);
        console.log(workoutSessionCreateUpdate);
        console.log(selectedDate);
        const request: ProgramSessionCreateRequest = {
            data: {
                author: {
                    id: customerItem.id!,
                    name: customerItem.username,
                },
                details: {
                    date: workoutSessionCreateFormData.getValues('sessionDate'),
                    id: workoutItem.id!,
                    name: workoutItem.title!,
                },
            },
        };
        if (workoutSessionCreateUpdate.selectedWorkout != undefined && workoutSessionCreateUpdate.selectedWorkout.id! != undefined) {
            const programSession: ProgramSession = await workoutSessionManager.create(request);
            const workoutSets = (await workoutSetManager.search(workoutSessionCreateFormData.getValues('sessionID'))).data;
            if (workoutSets != undefined && workoutSets.length > 0) {
                workoutSets.forEach(workoutSet => {
                    const workoutSetCreating: ProgramSessionSetCreateRequest = {
                        sessionID: programSession.id!,
                        authorId: customerItem.id!,
                        authorName: customerItem.username,
                        status: ProgramSessionSetStatusEnum.Done,
                        data: {
                            details: {
                                date: programSession.sessionDate,
                                exercise: {
                                    group: workoutSet.exerciseGroup,
                                    name: workoutSet.exerciseName,
                                    uuid: workoutSet.exerciseUuid,
                                },
                                reps: workoutSet.reps,
                                rest: workoutSet.rest,
                                weight: workoutSet.weight,
                                rir: workoutSet.rir,
                                rpe: workoutSet.rpe,
                            },
                        },
                    };
                    workoutSessionSetManager.create(programSession.id!, workoutSetCreating);
                });
                const transitRequest: SetTransitByExerciseRequest = {
                    sessionID: programSession.id,
                    authorID: customerItem.id!,
                };
                workoutSessionSetTransitManager.transitBySession(transitRequest);
            }
            await getWorkoutSessions();
            notificationManager.hide();
        } else {
            console.log("MIAOOO")
        }
    };

    const handleDuplicateWorkoutSession = async (sessionID: number) => {
        console.log(customerItem);
        console.log(workoutSessionCreateUpdate);
        console.log(selectedDate);
        const request: ProgramSessionCreateRequest = {
            id: sessionID,
            data: {
                author: {
                    id: customerItem.id!,
                    name: customerItem.username,
                },
                details: {
                    date: workoutSessionCreateFormData.getValues('sessionDate'),
                    id: workoutItem.id!,
                    name: workoutItem.title!,
                },
            },
        };
        await workoutSessionManager.duplicate(request);
         await getWorkoutSessions();
         notificationManager.hide();
    };

    useEffect(() => {
        getWorkoutSessions();
    }, []);

    const getSessionSummary = async (sesssionID: number) => {
        const response = await dashboardManager.getSessionSummary(sesssionID);
        store.dispatch(setSessionSummary({ response }));
    };

    const handleWorkoutSessionDetail = async (workoutID: number) => {
        const getWorkoutData = async () => {
            const response = await workoutSessionManager.getById(workoutID);
            store.dispatch(setWorkoutSessionItem({ response }));
            console.log(workoutID);
            console.log(response.id!);
            if (response != undefined) {
                const sets = (await workoutSessionSetManager.search(workoutID)).data;
                if (sets != undefined) {
                    store.dispatch(setWorkoutSessionSetItems({ sets }));
                }
            }
        };
        await getWorkoutData();
        await getSessionSummary(workoutID);
        navigationManager.navigateTo(RouteEnum.workoutSessionsSets);
    };

    const handleWorkoutSessionDelete = async (workoutSessionID: number) => {
        await workoutSessionManager.delete(workoutSessionID);
        getWorkoutSessions();
    };

    const handleStartChangeDate = async (workoutSessionID: number, sessionDate: string) => {
        workoutSessionCreateFormData.setValue('sessionID', workoutSessionID);
        workoutSessionCreateFormData.setValue('sessionDate', sessionDate);
        setNewSessionDate(true);
    };

    const handleChangeDate = async () => {
        const request: ProgramSessionUpdatDateRequest = {
            date: workoutSessionCreateFormData.getValues('sessionDate'),
        };
        await workoutSessionManager.updateDate(workoutSessionCreateFormData.getValues('sessionID'), request);
        getWorkoutSessions();
    };

    const handleSetDate = (date: any) => {
        const value = date as string;
        store.dispatch(setSelectedWorkoutSessionDate({ value }));
        console.log(value);
        setSelectedDate(value);
        console.log(selectedDate);
    };

    const resetCustomerCreateUpdateForm = () => {
        store.dispatch(resetWorkoutSessionCreateUpdate());
    };

    const workoutSessionCreateFormData = FormManager.getInstance().buildFormProxy<CustomerWorkoutSessionCreateSetFormData>(
        CustomerWorkoutSessionCreateSetFormData,
        handleCreateWorkoutSession,
        {
            sessionDate: workoutSessionCreateUpdate.sessionDate,
            sessionID: workoutSessionCreateUpdate.selectedWorkout != undefined ? workoutSessionCreateUpdate.selectedWorkout.id : 0,
        },
        'onChange',
    );

    const [newSessionDate, setNewSessionDate] = useState(new Boolean(false));

    const handleStartCreate = () => {
        notificationManager.show({
            title: 'Nuova seduta',
            type: PopupType.Info,
            icon: 'bi-calendar-check-fill',
            children: (
                <div className='App mt-2'>
                    <div className='col'>
                        <div className='d-flex justify-content-between mb-3' style={{ gap: 10 }}>
                            <div>
                                <input
                                    id='startDate'
                                    className='form-control'
                                    type='date'
                                    {...workoutSessionCreateFormData.register('sessionDate')}
                                    onChange={event => {
                                        workoutSessionCreateFormData.setValue('sessionDate', event.target.value as string);
                                        console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                        handleSetDate(event.target.value as string);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        await handleCreateWorkoutSession()
                    },
                },
                secondary: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
                close: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
            },
        });
    };

    const handleStartDuplicate = (sessionID: number) => {
        notificationManager.show({
            title: 'Duplica seduta',
            type: PopupType.Info,
            icon: 'bi-copy',
            children: (
                <div className='App mt-2'>
                    <div className='col'>
                        <div className='d-flex justify-content-between mb-3' style={{ gap: 10 }}>
                            <div>
                                <input
                                    id='startDate'
                                    className='form-control'
                                    type='date'
                                    {...workoutSessionCreateFormData.register('sessionDate')}
                                    onChange={event => {
                                        workoutSessionCreateFormData.setValue('sessionDate', event.target.value as string);
                                        console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                        handleSetDate(event.target.value as string);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        await handleDuplicateWorkoutSession(sessionID)
                    },
                },
                secondary: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
                close: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
            },
        });
    };

    const sessionEvents = () => {
        const events: EventCalendar[] = [];
        workoutSessions.map(sess => {
            const event: EventCalendar = {
                id: sess.id!,
                start: moment(sess.sessionDate).toDate(),
                end: moment(sess.sessionDate).toDate(),
                title: sess.sessionName!,
                allDay: true,
            };
            events.push(event);
        });
        return events;
    };

    const localizer = momentLocalizer(moment);

    return (
        <PageTransition className='mt-4 px-3 px-md-4'>
            {/* ── Page Header ──────────────────────────────────────────── */}
            <div
                className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 p-4 anim-slide-up'
                style={{
                    background: 'linear-gradient(135deg, #fff 0%, #fafafa 100%)',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}>
                <div>
                    <div className='d-flex align-items-center gap-2 mb-1'>
                        <i className='bi bi-calendar3' style={{ fontSize: '1.4rem', color: '#ff4949' }}></i>
                        <h4 className='mb-0 fw-bold' style={{ color: '#333' }}>{customerItem.username}</h4>
                    </div>
                    <p className='mb-0 mt-1' style={{ color: '#666', fontSize: '0.9rem' }}>
                        <span className='badge rounded-pill me-2' style={{ backgroundColor: '#ff4949', color: '#fff', fontSize: '0.8rem' }}>
                            {workoutSessions !== undefined ? workoutSessions.length : 0}
                        </span>
                        sedute totali
                    </p>
                </div>
                <div className='mt-3 mt-md-0'>
                    <Button
                        identifier='Nuova seduta'
                        icon={<i className='bi bi-plus-lg' style={{ fontSize: '0.9rem', color: 'white' }}></i>}
                        variant='primary'
                        onClick={() => handleStartCreate()}
                    />
                </div>
            </div>

            {/* ── Calendar ─────────────────────────────────────────────── */}
            <div
                className='mb-4 p-4 anim-slide-up'
                style={{
                    background: '#fff',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}>
                <div className='d-flex align-items-center gap-2 mb-3'>
                    <i className='bi bi-calendar-week' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                    <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Calendario</h6>
                </div>
                <BigCalendar
                    localizer={localizer}
                    onSelectEvent={(event: EventCalendar) => handleWorkoutSessionDetail(event.id)}
                    events={sessionEvents()}
                    startAccessor='start'
                    endAccessor='end'
                    style={{ height: 500 }}
                />
            </div>

            {/* ── Session List ─────────────────────────────────────────── */}
            {workoutSessions.length > 0 && (
                <div className='mb-4'>
                    <div className='d-flex align-items-center gap-2 mb-3'>
                        <i className='bi bi-list-ul' style={{ fontSize: '1rem', color: '#ff4949' }}></i>
                        <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>Elenco sedute</h6>
                        <span className='badge rounded-pill ms-1' style={{ backgroundColor: '#f2f2f2', color: '#666', fontSize: '0.72rem' }}>
                            {workoutSessions.length}
                        </span>
                    </div>
                    <div className='d-flex flex-column gap-2'>
                        {workoutSessions.map((workoutSession: ProgramSession, index: number) => (
                            <div
                                key={workoutSession.id || index}
                                className='app-card anim-stagger'
                                style={{
                                    '--anim-index': index,
                                    borderLeft: '3px solid #ff4949',
                                    padding: 0,
                                    overflow: 'hidden',
                                } as React.CSSProperties}>
                                <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between p-3'>
                                    <div className='d-flex align-items-center gap-3 mb-2 mb-md-0'>
                                        <i className='bi bi-calendar2-check' style={{ fontSize: '1.1rem', color: '#ff4949' }}></i>
                                        <div>
                                            <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>{workoutSession.sessionName}</h6>
                                            <span style={{ fontSize: '0.8rem', color: '#999' }}>
                                                {moment(workoutSession.sessionDate).format('D MMMM YYYY')}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='d-flex gap-2 flex-wrap'>
                                        <Button
                                            identifier='Dettagli'
                                            icon={<i className='bi bi-eye-fill' style={{ fontSize: '0.9rem', color: 'white' }}></i>}
                                            variant='primary'
                                            onClick={() => handleWorkoutSessionDetail(workoutSession.id!)}
                                        />
                                        <Button
                                            identifier='Duplica'
                                            icon={<i className='bi bi-copy' style={{ fontSize: '0.85rem' }}></i>}
                                            variant='secondary'
                                            onClick={() => handleStartDuplicate(workoutSession.id!)}
                                        />
                                        <Button
                                            identifier='Ripianifica'
                                            icon={<i className='bi bi-calendar-event' style={{ fontSize: '0.85rem' }}></i>}
                                            variant='secondary'
                                            onClick={() => handleStartChangeDate(workoutSession.id!, workoutSession.sessionDate!)}
                                        />
                                        <Button
                                            identifier='Elimina'
                                            icon={<i className='bi bi-trash3' style={{ fontSize: '0.85rem' }}></i>}
                                            variant='secondary'
                                            onClick={() => handleWorkoutSessionDelete(workoutSession.id!)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* ── Reschedule Panel ─────────────────────────────────────── */}
            {newSessionDate == true && (
                <div
                    className='row align-items-center justify-content-between px-4 mx-0 py-4 mb-4 anim-slide-up'
                    style={{
                        backgroundColor: '#f9f9f9',
                        borderRadius: 10,
                        border: '1px solid rgba(0,0,0,0.06)',
                        borderLeft: '3px solid #ff4949',
                    }}>
                    <div className='col-8 d-flex justify-content-start'>
                        <Calendar
                            identifier={''}
                            {...workoutSessionCreateFormData.register('sessionDate')}
                            selected={
                                workoutSessionCreateFormData.getValues('sessionDate') == undefined
                                    ? new Date()
                                    : moment(workoutSessionCreateFormData.getValues('sessionDate')).toDate()
                            }
                            onChange={date => {
                                workoutSessionCreateFormData.setValue('sessionDate', date as Date);
                                console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                            }}
                        />
                    </div>
                    <div className='col-4 d-flex justify-content-end gap-3'>
                        <Button
                            identifier='Salva'
                            variant='primary'
                            onClick={() => {
                                handleChangeDate();
                                setNewSessionDate(false);
                            }}
                        />
                        <Button
                            identifier='Annulla'
                            variant='secondary'
                            onClick={() => {
                                setNewSessionDate(false);
                                workoutSessionCreateFormData.resetField('sessionDate');
                                workoutSessionCreateFormData.resetField('sessionID');
                            }}
                        />
                    </div>
                </div>
            )}
        </PageTransition>
    );
};
